'use client';

import { useTranslation } from '@/app/i18n/client';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useContext } from 'react';
import AppContext from './AppContext';
import Copyright from './Copyright';
import Logo from './Logo';

export default function ErrorPlaceholder() {
  const { i18n } = useContext(AppContext);
  const { t } = useTranslation(i18n?.lng);

  return (
    <>
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center',
            height: '100vh',
            minHeight: '100vh',
          }}
        >
          <Box
            sx={{
              my: 4,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="h4" component="h1" gutterBottom>
              <Logo />
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 'auto',
              mb: 6,
            }}
          >
            <Alert severity="error">
              <AlertTitle>{t('Some error occurred')}</AlertTitle>
              {t('Please try again later')}
            </Alert>
          </Box>
          <Box
            sx={{
              mt: 'auto',
              mb: 6,
            }}
          >
            <Copyright />
          </Box>
        </Box>
      </Container>
    </>
  );
}
